import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const ULContainer = styled.ul`
  width: 100%;
  padding: 0 10px 8px 10px;
  background-color: ${COLOR.GRAY200.code};
  overflow-y: auto;
`;
